import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Button from '@components/ui/Button'

const HeroBanner = () => {
  const { t } = useTranslation()

  return (
    <section className="relative bg-blue-600 text-white py-20 overflow-hidden">
      {/* 左侧建筑群 */}
      <div className="absolute left-0 bottom-0 pointer-events-none">
        <div className="flex items-end">
          {/* 建筑1 */}
          <div className="w-20 h-48 bg-blue-700 opacity-60 rounded-tr-lg"></div>
          {/* 建筑2 */}
          <div className="w-24 h-64 bg-blue-700 opacity-70 rounded-tr-lg"></div>
          {/* 建筑3 */}
          <div className="w-28 h-56 bg-blue-700 opacity-80 rounded-tr-lg"></div>
          {/* 建筑4 */}
          <div className="w-32 h-72 bg-blue-700 opacity-90 rounded-tr-lg"></div>
        </div>
      </div>
      
      {/* 右侧建筑群 */}
      <div className="absolute right-0 bottom-0 pointer-events-none">
        <div className="flex items-end">
          {/* 建筑1 */}
          <div className="w-32 h-72 bg-blue-700 opacity-90 rounded-tl-lg"></div>
          {/* 建筑2 */}
          <div className="w-28 h-56 bg-blue-700 opacity-80 rounded-tl-lg"></div>
          {/* 建筑3 */}
          <div className="w-24 h-64 bg-blue-700 opacity-70 rounded-tl-lg"></div>
          {/* 建筑4 */}
          <div className="w-20 h-48 bg-blue-700 opacity-60 rounded-tl-lg"></div>
        </div>
      </div>
      
      {/* 底部地基 */}
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-blue-800 opacity-40 pointer-events-none"></div>
      
      {/* 底部装饰线 */}
      <div className="absolute bottom-12 left-0 right-0 h-2 bg-blue-700 opacity-30 pointer-events-none"></div>
      <div className="absolute bottom-16 left-0 right-0 h-1 bg-blue-700 opacity-20 pointer-events-none"></div>
      
      {/* 顶部装饰 */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-blue-500 opacity-50 pointer-events-none"></div>
      
      {/* 背景装饰 */}
      <div className="absolute top-10 left-20 w-32 h-32 bg-blue-500 opacity-20 rounded-full blur-2xl pointer-events-none"></div>
      <div className="absolute top-10 right-20 w-32 h-32 bg-blue-500 opacity-20 rounded-full blur-2xl pointer-events-none"></div>
      
      <div className="relative container section-padding">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-10 leading-tight">
            {t('home.hero.title')}
          </h1>
          
        </div>
      </div>
    </section>
  )
}

export default HeroBanner 